import React from 'react'
import AsideMenu from './aside_menu'

const Aside = () => {
    const hash = window.location.hash

    return (
        hash === '#aside' && <AsideMenu />
    )
}

export default Aside



// WEBPACK FOOTER //
// ./src/m_header/pages/aside/index.js